import EdicaoLoteProduto from './EdicaoLoteProduto'
import { Grid } from '@mui/material'
import PrimeTable from '../../../../components/PrimeTable'

const CODIGO_PROGRAMA = 'CtrlProduto'

const LoteProduto = ({ idProduto, tela, setTela, dadosLote, setDadosLote }) => {
  const voltar = () => {
    setTela('opcoes')
    setDadosLote([])
  }

  const handleClick = (linhaOriginal) => {
    setDadosLote(linhaOriginal)
    setTela('opcoesLote')
  }

  return (
    <Grid container xs={12}>
      {tela === 'opcoesLote' ? (
        <EdicaoLoteProduto
          {...{
            idProduto,
            dadosLote,
            voltar,
            setTela,
            codigoPrograma: CODIGO_PROGRAMA,
          }}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item xs={12}>
              <PrimeTable
                codigo="CtrlProduto"
                action="listaLote"
                rows={10}
                habSearch
                head={[
                  'Produto',
                  'Fornecedor',
                  'Nr. Lote',
                  'Dt. Fabricação',
                  'Dt. Validade',
                ]}
                line={(item) => [
                  item[1][1],
                  item[2][1],
                  item[3],
                  item[4],
                  item[5],
                ]}
                collumnsDate={[3, 4]}
                parametros={{ idProduto }}
                onRowSelect={handleClick}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default LoteProduto
